import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F7] px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center omni-rise">
        <div className="h-16 w-16 rounded-2xl bg-[#EFEFEA] flex items-center justify-center mx-auto">
          <XCircle className="h-9 w-9 text-[#8C8C85]" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-[#171716] mt-6">Checkout cancelled</h1>
        <p className="text-[#5F5F5B] mt-2">No worries — you haven't been charged. You can upgrade anytime.</p>
        <button onClick={() => navigate("/")} data-testid="back-to-app-button" className="mt-8 rounded-full bg-[#1F2421] text-white px-6 py-3 font-medium hover:bg-[#2D6A4F]" style={{ transition: "background-color 0.2s ease" }}>
          Back to OmniAI
        </button>
      </div>
    </div>
  );
}
